"use client"

import { Button } from "@/ui/shared/components/button"
import Link from "next/link"
import { cn } from "@/ui/shared/utils"

interface HeaderRegistrationButtonProps {
    className?: string
    fullWidth?: boolean
}

export function HeaderRegistrationButton({ className, fullWidth = false }: HeaderRegistrationButtonProps = {}) {
    return (
        <Button asChild variant="primary" className={cn("text-white onest-button", fullWidth ? "w-full py-2" : "px-3 sm:px-6 py-2", className)}>
            <Link href="/register">Регистрация</Link>
        </Button>
    )
}
